import api from '@/api/infections'
import ice from '@/sui/tools/ice'

const state = {
  bact: {
    id: '',
    all: [],
    available: false
  },

  pneu: {
    id: '',
    all: [],
    available: false
  }
}

const getters = {
}

// actions
const actions = {
  getPneu ({ commit }, request) {
    return api.getPneu(request).then(
      r => {
        if (r.data.err == null) {
          commit(
            'setPneu',
            {
              id: request.surv,
              all: r.data.v
            }
          )
        }
        return r
      }
    )
  },

  getBact ({ commit }, request) {
    return api.getBact(request).then(
      r => {
        if (r.data.err == null) {
          commit(
            'setBact',
            {
              id: request.surv,
              all: r.data.v
            }
          )
        }
        return r
      }
    )
  }
}

// mutations
const mutations = {
  setBact (state, v) {
    state.bact.id = v.id
    state.bact.all = ice.freeze(v.all)
    state.bact.available = true
  },

  setPneu (state, v) {
    state.pneu.id = v.id
    state.pneu.all = ice.freeze(v.all)
    state.pneu.available = true
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
